import React from 'react';

/**
 * Captura erros de renderizacao e evita que a tela inteira quebre.
 * Nao elimina a causa raiz, mas reduz impacto e melhora a estabilidade.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Mantem log para investigacao; o usuario ve fallback.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] erro:', error, info);
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      const message = this.props.fallback || (
        <div className="p-4 text-sm text-destructive">
          Ocorreu um erro ao exibir a tela de chamadas. Recarregue a pagina para tentar novamente.
        </div>
      );
      return message;
    }
    return this.props.children;
  }
}

